import styled from "styled-components";
import { Colors } from "../../constants/Colors";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
`;

export const Title = styled.div`
    color:  ${Colors.primary[100]};
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    
    h1 {
        margin: 0;
    }  
`;

export const NotFound = styled.td`
    padding: 2rem;
    text-align: center;
    width: 100%;
`;